import { render, staticRenderFns } from "./NavigationLabel.vue?vue&type=template&id=5f5e0917&scoped=true&"
import script from "./NavigationLabel.vue?vue&type=script&lang=js&"
export * from "./NavigationLabel.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLabel.vue?vue&type=style&index=0&id=5f5e0917&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e0917",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
